module.exports = __webpack_public_path__ + "static/media/banner.63a2aeb3.png";